import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="px-4 py-4">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-2 -ml-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </button>
            <h1 className="text-lg font-bold">개인정보처리방침</h1>
          </div>
        </div>
      </div>

      <div className="px-4 py-6">
        <div className="bg-white rounded-xl shadow-sm p-6 space-y-6">
          <div>
            <p className="text-sm text-gray-600 mb-4">시행일: 2025년 1월 1일</p>
          </div>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. 개인정보의 처리 목적</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 회원 가입 및 관리</li>
              <li className="pl-4">• 시공 서비스 제공 및 계약 이행</li>
              <li className="pl-4">• 고객 상담 및 불만 처리</li>
              <li className="pl-4">• 마케팅 및 광고 활용</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. 개인정보의 처리 및 보유 기간</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용기간 또는 법령에 따른 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 회원 정보: 회원 탈퇴 시까지</li>
              <li className="pl-4">• 계약 및 청약철회 관련: 5년</li>
              <li className="pl-4">• 대금결제 및 재화 등의 공급 관련: 5년</li>
              <li className="pl-4">• 소비자 불만 또는 분쟁처리 관련: 3년</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. 개인정보의 제3자 제공</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. 개인정보처리 위탁</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li className="pl-4">• SMS 발송: 알리고</li>
              <li className="pl-4">• 푸시 알림: Firebase Cloud Messaging</li>
              <li className="pl-4">• 이메일 발송: 이메일 서비스 제공업체</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. 정보주체의 권리·의무 및 그 행사방법</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              정보주체는 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 개인정보 열람요구</li>
              <li className="pl-4">• 오류 등이 있을 경우 정정 요구</li>
              <li className="pl-4">• 삭제요구</li>
              <li className="pl-4">• 처리정지 요구</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. 처리하는 개인정보의 항목</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 다음의 개인정보 항목을 처리하고 있습니다.
            </p>
            <div className="mt-3 space-y-2">
              <div>
                <p className="text-sm font-medium text-gray-800">필수항목</p>
                <ul className="mt-1 space-y-1 text-sm text-gray-700">
                  <li className="pl-4">• 성명, 연락처(휴대전화번호)</li>
                  <li className="pl-4">• 시공 주소, 프로젝트 정보</li>
                  <li className="pl-4">• 서비스 이용 기록, 접속 로그, IP 주소</li>
                  <li className="pl-4">• 기기 정보(앱 버전, OS 버전, 기기 모델)</li>
                </ul>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-800">선택항목</p>
                <ul className="mt-1 space-y-1 text-sm text-gray-700">
                  <li className="pl-4">• 이메일 주소</li>
                  <li className="pl-4">• 회사명(소장의 경우)</li>
                  <li className="pl-4">• 카메라(사진 촬영 시)</li>
                  <li className="pl-4">• 저장공간(파일 업로드/다운로드 시)</li>
                </ul>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-800">자동 수집 항목</p>
                <ul className="mt-1 space-y-1 text-sm text-gray-700">
                  <li className="pl-4">• 광고 ID (Firebase Analytics)</li>
                  <li className="pl-4">• 앱 사용 통계 및 이벤트 로그</li>
                  <li className="pl-4">• FCM 토큰 (푸시 알림용)</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">7. 개인정보의 파기</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 전자적 파일 형태: 복구 불가능한 방법으로 삭제</li>
              <li className="pl-4">• 종이 문서: 분쇄기로 분쇄하거나 소각</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">8. 앱 권한 사용</h2>
            <p className="text-sm text-gray-700 leading-relaxed mb-3">
              건기 프로젝트 앱은 다음과 같은 권한을 요청하며, 명시된 목적으로만 사용합니다.
            </p>
            <div className="space-y-2">
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">알림 권한</p>
                <p className="text-sm text-gray-600">프로젝트 상태 변경, 메시지 수신 알림</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">카메라 권한 (선택)</p>
                <p className="text-sm text-gray-600">현장 사진 촬영 및 업로드</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">저장공간 권한 (선택)</p>
                <p className="text-sm text-gray-600">파일 업로드 및 다운로드</p>
              </div>
            </div>
            <p className="text-sm text-gray-700 mt-3">
              * 선택 권한은 거부하더라도 해당 기능 외 다른 서비스 이용이 가능합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">9. 개인정보의 안전성 확보 조치</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 개인정보 취급 직원의 최소화 및 교육</li>
              <li className="pl-4">• 개인정보에 대한 접근 제한</li>
              <li className="pl-4">• 접속기록의 보관 및 위변조 방지</li>
              <li className="pl-4">• 개인정보의 암호화</li>
              <li className="pl-4">• 해킹 등에 대비한 기술적 대책</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">10. 아동의 개인정보 보호</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 만 14세 미만 아동의 개인정보를 수집하지 않습니다. 만 14세 미만 아동의 개인정보가 수집된 사실을 인지한 경우 즉시 해당 정보를 삭제하겠습니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">11. 개인정보의 국외 이전</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              건기 프로젝트는 서비스 제공을 위해 다음과 같이 개인정보를 국외로 이전합니다.
            </p>
            <div className="mt-3 bg-gray-50 rounded-lg p-4 space-y-2">
              <p className="text-sm text-gray-700">
                <span className="font-medium">이전받는 자:</span> Google LLC (Firebase)
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">이전 국가:</span> 미국
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">이전 항목:</span> FCM 토큰, 앱 사용 통계
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">이전 목적:</span> 푸시 알림 발송, 앱 분석
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">보유 기간:</span> 서비스 이용 기간
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">12. 개인정보 보호책임자</h2>
            <div className="bg-gray-50 rounded-lg p-4 space-y-2">
              <p className="text-sm text-gray-700">
                <span className="font-medium">성명:</span> 김건기
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">직책:</span> 개인정보보호책임자
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">연락처:</span> 1566-0622
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">이메일:</span> privacy@geongi.kr
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">13. 개인정보 처리방침 변경</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              이 개인정보처리방침은 2025년 1월 1일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">14. 권익침해 구제방법</h2>
            <p className="text-sm text-gray-700 leading-relaxed mb-3">
              정보주체는 개인정보침해로 인한 구제를 받기 위하여 다음 기관에 문의하실 수 있습니다.
            </p>
            <div className="space-y-3">
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">개인정보보호 종합포털</p>
                <p className="text-sm text-gray-600">privacy.kisa.or.kr / 118</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">개인정보 침해신고센터</p>
                <p className="text-sm text-gray-600">(한국인터넷진흥원 운영) / 118</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">개인정보 분쟁조정위원회</p>
                <p className="text-sm text-gray-600">www.kopico.go.kr / 1833-6972</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-800">경찰청 사이버수사국</p>
                <p className="text-sm text-gray-600">cyberbureau.police.go.kr / 182</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">15. 데이터 삭제 요청</h2>
            <p className="text-sm text-gray-700 leading-relaxed mb-3">
              사용자는 언제든지 자신의 개인정보 삭제를 요청할 수 있습니다.
            </p>
            <div className="bg-blue-50 rounded-lg p-4">
              <p className="text-sm font-medium text-gray-800 mb-2">데이터 삭제 요청 방법:</p>
              <ul className="space-y-1 text-sm text-gray-700">
                <li className="pl-4">• 이메일: privacy@geongi.kr</li>
                <li className="pl-4">• 전화: 1566-0622</li>
                <li className="pl-4">• 앱 내 설정 > 계정 삭제</li>
              </ul>
              <p className="text-sm text-gray-600 mt-2">
                * 삭제 요청 후 30일 이내에 처리되며, 법령에 따라 보존이 필요한 정보는 해당 기간 동안 보관 후 삭제됩니다.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;